<div class="dialog-content-wrapper" style="margin: -24px;">
    <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{translations.lblShipperForm}}</span>
            <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>


    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">

        <form [formGroup]="formGroup" novalidate>

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="47">
                    <input id="Code" matInput placeholder="{{translations.txtCode}}" 
                    formControlName="Code" [(ngModel)]="shipper.Code" required maxlength="25" >
                    <mat-error *ngIf="formGroupErrors.Code.required">
                        {{translations.msgPleaseEnterCode}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="47">
                    <input matInput placeholder="{{translations.txtName}}" 
                    formControlName="Name" [(ngModel)]="shipper.Name" required maxlength="500">
                    <mat-error *ngIf="formGroupErrors.Name.required">
                        {{translations.msgPleaseEnterName}}
                    </mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start start" >
                <mat-form-field class="example-full-width" fxFlex.xs="100" fxFlex="100">
                    <textarea matInput placeholder="{{translations.txtAddress}}" 
                    formControlName="Address" [(ngModel)]="shipper.Address" 
                    maxlength="500" required></textarea>
                   <mat-error *ngIf="formGroupErrors.Address.required">
                        {{translations.msgPleaseEnterAddress}}
                    </mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="mr-24 {{countryRequired ? 'ng-invalid mat-input-invalid mat-form-field-invalid' : ' mat-input-container mat-form-field ng-tns-c18-22 mat-form-field-type-mat-input mat-form-field-can-float mat-primary ng-touched mat-form-field-should-float ng-dirty ng-valid'}}" fxFlex.xs="100" fxFlex="47">
                     <input type="text" placeholder="{{translations.cmbCountryId}} *" 
                    matInput [formControl]="countryFilterCtrl" [matAutocomplete]="auto"  (blur)="onCountryBlur($event)">
                    <!-- <mat-spinner *ngIf="loadingCountry" [diameter]="20" style="float:left;"></mat-spinner> -->
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                        <mat-option *ngFor="let country of countryList" 
                        value="{{country.Description}} ({{country.Code}})"
                        (onSelectionChange)="onCountrySelect(country.Id)"
                        >{{country.Description}} ({{country.Code}})</mat-option>
                    </mat-autocomplete>
                    <mat-hint align="start" *ngIf="countryRequired" style="color:red">{{translations.msgPleaseEnterCountry}}</mat-hint>
                </mat-form-field>
                <mat-form-field class="mr-24 {{cityRequired ? 'ng-invalid mat-input-invalid mat-form-field-invalid' : ' mat-input-container mat-form-field ng-tns-c18-22 mat-form-field-type-mat-input mat-form-field-can-float mat-primary ng-touched mat-form-field-should-float ng-dirty ng-valid'}}" fxFlex.xs="100" fxFlex="47">
                         <input type="text" placeholder="{{translations.cmbCityId}} *" 
                    matInput [formControl]="cityFilterCtrl" [matAutocomplete]="auto2" (blur)="onCityBlur($event)">
                    <mat-autocomplete autoActiveFirstOption #auto2="matAutocomplete">
                        <mat-option *ngFor="let city of cityList" 
                        value="{{city.Description}} ({{city.Code}})"
                        (onSelectionChange)="onCitySelect(city.Id)"
                        >{{city.Description}} ({{city.Code}})</mat-option>
                    </mat-autocomplete>
                    <mat-hint align="start" *ngIf="cityRequired" style="color:red">{{translations.msgPleaseEnterCity}}</mat-hint>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="mr-24 {{pcRequired ? 'ng-invalid mat-input-invalid mat-form-field-invalid' : ' mat-input-container mat-form-field ng-tns-c18-22 mat-form-field-type-mat-input mat-form-field-can-float mat-primary ng-touched mat-form-field-should-float ng-dirty ng-valid'}}" fxFlex.xs="100" fxFlex="47">
                           <input type="text" placeholder="{{translations.cmbPostalCodeId}} *" 
                    matInput [formControl]="psFilterCtrl" [matAutocomplete]="auto3" (blur)="onPCBlur($event)">
                    <mat-autocomplete autoActiveFirstOption #auto3="matAutocomplete">
                        <mat-option *ngFor="let pc of postalCodeList" 
                        value="{{pc.Description}} ({{pc.Code}})"
                        (onSelectionChange)="onPCSelect(pc.Id)"
                        >{{pc.Description}} ({{pc.Code}})</mat-option>
                    </mat-autocomplete>
                    <mat-hint align="start" *ngIf="pcRequired" style="color:red">{{translations.msgPleaseEnterPostalCode}}</mat-hint>
                </mat-form-field>
                <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="47">
                    <input matInput placeholder="{{translations.txtWebsite}}" [(ngModel)]="shipper.Website" maxlength="50" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="47">
                    <input matInput placeholder="{{translations.txtVAT}}" 
                    formControlName="VAT" [(ngModel)]="shipper.VAT" maxlength="15" required>
                    <mat-error *ngIf="formGroupErrors.VAT.required">
                        {{translations.msgPleaseEnterVAT}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="47">
                    <input matInput placeholder="{{translations.txtContactPerson}}" [(ngModel)]="shipper.ContactPerson" maxlength="500" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
            </div> 

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="47">
                    <input matInput type="tel" placeholder="{{translations.txtPhone}}" [(ngModel)]="shipper.Phone" maxlength="15" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
                <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="47">
                    <input matInput type="email" placeholder="{{translations.txtEmail}}" 
                    formControlName="Email" [(ngModel)]="shipper.Email" maxlength="500"> 
                    <mat-error *ngIf="formGroupErrors.Email.pattern">
                        {{translations.msgEnterValidEmail}}
                    </mat-error>
                    
                </mat-form-field>        
            </div> 
            <div fxLayout="row" fxLayoutAlign="start right">
                <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="100">
                    <input matInput placeholder="{{translations.txtDeliveryCondition}}" 
                    formControlName="DeliveryCondition" [(ngModel)]="shipper.DeliveryCondition" 
                    maxlength="25" 
                    required>
                    <mat-error *ngIf="formGroupErrors.DeliveryCondition.required">
                        {{translations.msgPleaseEnterDeliveryCondition}}
                    </mat-error>
                    
                </mat-form-field>                                
            </div>
            <div fxLayout="row" fxLayoutAlign="start right" class="user-active-slider">
                <label style="float: right;display: inline-block;margin-right: 20px;" for="sliderActive" style="float: left;display: inline-block;">{{translations.lblShipperStatus}}</label>
                <mat-slide-toggle style="float: right;display: inline-block;margin-right: 20px;" formControlName="IsActive" [checked]="shipper.IsActive" [(ngModel)]="shipper.IsActive" required>{{translations.chkIsActive}}</mat-slide-toggle>
            </div>
        </form>        
    </div>
    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="left">
        <button mat-raised-button color="accent" aria-label="SAVE" [disabled]="invalidForm" (click)="save();" fxFlex="47">
            {{translations.btnSave}}
        </button>
        <button mat-raised-button color="warn" aria-label="CLOSE" mat-dialog-close fxFlex="47">
            {{translations.btnClose}}
        </button>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/shipper/shipper-edit-form/shipper-edit-form.component.html